import { FC, memo } from 'react';

import { IconBaseProps } from 'icons/IconBase';

export const IconLanguageMark: FC<IconBaseProps> = memo(
  ({ width = 20, height = 15, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M1 6.25L7.5 12.75L19 1.25" stroke="black" strokeWidth="2" />
    </svg>
  ),
);
